export enum BtnVariant {
    Primary,
    Secondary,
    Tertiary,
    White,
    Outline,
    Link,
    OutlinePrimary,
    Custom,
}